import { memo } from 'react';
import { CallRole_Utils } from '@/enums';
import type { Transcribe } from '@/types';
import { cx } from '@trinity/chat-components';
import { roleIsModeratorLike } from '@trinity/chat-components';
import styles from './style/Monologue.module.css';

type SpeakerProps = {
  className?: string;
  displayName: string;
  speaker: Transcribe.Speaker;
};

export const Speaker = memo((props: SpeakerProps) => {
  const hasModeratorRole = roleIsModeratorLike(props.speaker?.role);
  const isModerator = hasModeratorRole && props.speaker?.name != 'Moderator';

  return (
    <div className={cx(styles.speaker, props.className)}>
      {props.displayName}
      {isModerator && (
        <span className={styles.speakerRole}>
          ({CallRole_Utils.getName(props.speaker.role)})
        </span>
      )}
    </div>
  );
});